import { state } from "@/state/modules/clientzone/notifications/state";
import { mutations } from "@/state/modules/clientzone/notifications/mutations";
import { getters } from "@/state/modules/clientzone/notifications/getters";
import { actions } from "@/state/modules/clientzone/notifications/actions";

const notificationModule = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}

export default notificationModule
